import { Tag } from 'antd';
import { t } from 'i18next';
import { STATUS_ID } from '../pages/risk-register/STATUS_ID';

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const getTagStatus = (i18n, id, en, th) => {
    switch (id) {
        case STATUS_ID.DRAFT:
            return (
                <Tag className="rounded-xl text-gray border-gray bg-white -my-1">
                    {i18n.language === 'en' ? en : th}
                </Tag>
            );
        case STATUS_ID.REVIEWED:
            return (
                <Tag className="rounded-xl text-success border-success bg-white -my-1">
                    {i18n.language === 'en' ? en : th}
                </Tag>
            );
        case STATUS_ID.REVISE:
            return (
                <Tag className="rounded-xl text-error border-error bg-white -my-1">
                    {i18n.language === 'en' ? en : th}
                </Tag>
            );
        case STATUS_ID.WAITING_FOR_REVIEW:
            return (
                <Tag className="rounded-xl text-wait border-wait bg-white -my-1">
                    {i18n.language === 'en' ? en : th}
                </Tag>
            );

        default:
            return '-';
    }
};

const getTagAction = (e) => {
    if (e === 'Dismiss') {
        return (
            <Tag
                className="rounded-xl -my-1 text-center"
                style={{ color: '#65707A', borderColor: '#65707A' }}
            >
                {t('COOKIE.Dismiss')}
            </Tag>
        );
    } else if (e === 'Informed') {
        return (
            <Tag
                className="rounded-xl -my-1 text-center"
                style={{ color: '#F9C153', borderColor: '#F9C153' }}
            >
                {t('COOKIE.Informed')}
            </Tag>
        );
    } else if (e === 'Accepted') {
        return (
            <Tag
                className="rounded-xl -my-1 text-center"
                style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
            >
                {t('COOKIE.Accepted')}
            </Tag>
        );
    } else if (e === 'Rejected') {
        return (
            <Tag
                className="rounded-xl -my-1 text-center"
                style={{ color: '#F0536F', borderColor: '#F0536F' }}
            >
                {t('COOKIE.Rejected')}
            </Tag>
        );
    } else {
        return <>-</>;
    }
};

const getTagDay = (e) => {
    if (e > 30) {
        return (
            <Tag className="rounded-xl -my-1" color="#1890FF">
                {e}
            </Tag>
        );
    } else if (e === null) {
        return (
            <Tag className="text-xs rounded-xl -my-1" color="#1890FF">
                {t('Consent.NoExpiry')}
            </Tag>
        );
    } else if (e <= 0) {
        return (
            <Tag className="text-xs rounded-xl -my-1" color="#F0536F">
                {e}
            </Tag>
        );
    } else if (e <= 7) {
        return (
            <Tag className="text-xs rounded-xl -my-1" color="#F9C153">
                {e}
            </Tag>
        );
    } else {
        return (
            <Tag className="text-xs rounded-xl -my-1" color="#1890FF">
                {e}
            </Tag>
        );
    }
};

export let toUtf8 = function (text) {
    let surrogate = encodeURIComponent(text);
    let result = '';
    for (let i = 0; i < surrogate.length; ) {
        let character = surrogate[i];
        i += 1;
        if (character === '%') {
            let hex = surrogate.substring(i, (i += 2));
            if (hex) {
                result += String.fromCharCode(parseInt(hex, 16));
            }
        } else {
            result += character;
        }
    }
    return result;
};

export const toBuddhistYear = (moment, format) => {
    let christianYear = moment.format('YYYY');
    let buddhishYear = (parseInt(christianYear) + 543).toString();
    return moment
        .format(
            format
                .replace('YYYY', buddhishYear)
                .replace('YY', buddhishYear.substring(2, 4))
        )
        .replace(christianYear, buddhishYear);
};

export function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onload = function () {
            let dataUrl = reader.result;
            let base64 = dataUrl.split(',')[1];
            // to utf-8
            base64 = toUtf8(base64);
            resolve(base64);
        };
        reader.readAsDataURL(blob);
    });
}

export const convertBase64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    const byteCharacters = window.atob(content); //method which converts base64 to binary
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
        type: contentType,
    }); //statement which creates the blob
    return blob;
};

function convertToISODateTime(dateTimeString) {
    if (dateTimeString) {
        const [datePart, timePart] = dateTimeString?.split(' ');
        const [day, month, year] = datePart?.split('/');
        const [hours, minutes] = timePart?.split(':');
        // Create a Date object with the given date and time components
        const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
        // Use Intl.DateTimeFormat to format the Date object as ISO date-time
        const isoDateTime = date.toISOString();
        return isoDateTime;
    }
    return '';
}

function getOriginalImageDimensions(imageUrl, callback) {
    const img = new Image();
    img.onload = function () {
        const originalWidth = this.width;
        const originalHeight = this.height;
        callback(originalWidth, originalHeight);
    };
    img.src = imageUrl;
}

function calculateImageWidth(logo) {
    const img = new Image();
    img.src = logo;
    const aspectRatio = img.width / img.height;
    // Calculate the width based on the target height
    const targetWidth = Math.round(100 * aspectRatio);
    return isNaN(targetWidth) ? 100 : targetWidth;
}

const loadImage = (setImageDimensions, imageUrl) => {
    if (imageUrl) {
        const img = new Image();
        img.onload = function () {
            const width = calculateImageWidth(this.width, this.height, 100);
            if (!isNaN(width)) setImageDimensions(width);
        };
        img.onerror = (err) => {
            console.log('img error');
            console.error(err);
        };
        img.src = imageUrl;
    }
};

const textOnly = (text) => text?.replace(/<\/?[^>]+(>|$)/g, '');

const filterNull = (array) => array.filter((item) => item !== null);

export {
    textOnly,
    filterNull,
    getBase64,
    getTagStatus,
    getTagDay,
    getTagAction,
    loadImage,
    calculateImageWidth,
    convertToISODateTime,
    getOriginalImageDimensions,
};
